import globalEvents from "shared/events"
import withModel from "@kaspernj/api-maker/build/with-model"

export default function wooftechModelLoadWrapper(wrappedComponent, modelClass, args = {}) {
  args.events = globalEvents

  return withModel(wrappedComponent, modelClass, args)
}
